import * as React from 'react';

import cx from 'classnames';

export interface DashedBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  borderColor?: string;
  borderWidth?: number;
  dashLength?: number;
  gapLength?: number;
  borderRadius?: number;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export function DashedBox({
  borderColor = 'currentColor',
  borderWidth = 2,
  dashLength = 4,
  gapLength = 4,
  borderRadius = 8,
  children,
  className,
  ...props
}: DashedBoxProps) {
  return (
    <div className={cx('relative', className)} {...props}>
      <svg className="absolute inset-0 w-full h-full pointer-events-none">
        <rect
          x={borderWidth / 2}
          y={borderWidth / 2}
          width={`calc(100% - ${borderWidth}px)`}
          height={`calc(100% - ${borderWidth}px)`}
          fill="none"
          stroke={borderColor}
          strokeWidth={borderWidth}
          strokeDasharray={`${dashLength} ${gapLength}`}
          rx={borderRadius}
          ry={borderRadius}
        />
      </svg>
      <div className="relative">{children}</div>
    </div>
  );
}
